import { render, staticRenderFns } from "./cardWhite.vue?vue&type=template&id=bc48a75a&scoped=true&"
import script from "./cardWhite.vue?vue&type=script&lang=js&"
export * from "./cardWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48a75a",
  null
  
)

export default component.exports